import React from 'react';
import Section from './Section';

function Skills() {
  return (
    <Section title="Technical Skills">
      <ul>
        <li>Languages: JavaScript, TypeScript, HTML, CSS, Java, R, Swift, Python</li>
        <li>Database: Postgres, MySQL, MongoDB, SQL</li>
        <li>Frameworks: React.js, Vue.js, Spring, Node.js, Express.js, SwiftUI, WordPress, Spring</li>
        <li>Tools: Git, Unix, Maven, Figma, PowerBI, Azure, REST APIs, Selenium, Vim, VS Code</li>
        <li>General Skills: Data Analysis, UI/UX Design, Web Development, Robotic Process Automation, Data Extraction, Dashboard Development, IT Support, Agile Methodologies, Technical Problem Solving</li>
      </ul>
    </Section>
  );
}

export default Skills;